export default __webpack_public_path__ + "static/char-s-14-chs-7b6c8e927bc79ba2ad5056bfe22c804d.webp";